<template>
  <div class="status">
    <div class="status__drawing">
      <span :class="drawingLine" class="drawing__line" />
      <span :class="drawingContainer" class="drawing__container" />
      <span class="drawing__circle" />
      <span :class="drawingStatus" />
    </div>

    <h1 class="status__title">
      <slot name="title" />
    </h1>

    <h5 class="status__subtitle">
      <slot name="subtitle" />
    </h5>

    <q-btn @click="goToPreviousPath" class="status__btn" flat>
      <slot name="btn" />
    </q-btn>
  </div>
</template>

<script>
  import { PREVIOUS_PATH } from '../../variables'
  import { getSessionStorage } from '../../functions'

  export default {
    name: 'Base',

    props: {
      status: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        path: '',
      }
    },

    computed: {
      drawingLine() {
        return `drawing__line--${this.status}`
      },

      drawingContainer() {
        return `drawing__container--${this.status}`
      },

      drawingStatus() {
        return `drawing__status--${this.status}`
      },
    },

    mounted() {
      this.getPreviousPath()
    },

    methods: {
      getPreviousPath() {
        const previousPath = getSessionStorage(PREVIOUS_PATH)

        this.path = '/embarque/passageiros'
        if (previousPath === '/embarque') {
          this.path = '/embarque'
        }
      },

      goToPreviousPath() {
        this.$router.push(this.path)
      },
    },
  }
</script>

<style lang="scss">
  @import "../../scss/views/status/base";
</style>
